import { REDUX_WEATHER_WARNINGS_FETCH_INIT, weatherWarningsFetchTypes } from './reducer.js';

/**
 * Extended Array type that manage warningsRequest
 * Prevents multiple requests from modules
 */
export function WarningRequestArray(): {
  updatePageLoadTime: (pageTime: number) => void;
  addPageRequest: (time: number, request: string, actionType: weatherWarningsFetchTypes) => boolean;
  showArr: () => [number, string][];
} {
  let pageLoadTime = 0;
  const requestArr: Array<[number, string]> = [];
  const sortByTime = () => requestArr.sort(([timeA], [timeB]) => timeA - timeB);

  /** Remove items in array that are previous to pageTimeLoadTime */
  const updatePageLoadTime = (pageTime: number) => {
    sortByTime();
    pageLoadTime = pageTime;
    const index = requestArr.findIndex(([time]) => time >= pageLoadTime);
    if (index >= 0) {
      requestArr.splice(0, index);
    } else {
      // no items are higher than page load time so delete all
      requestArr.splice(0, requestArr.length);
    }
  };

  /** Checks if request is after page load time and is not already in request arr */
  const shouldMakePageRequest = (
    requestTime: number,
    request: string,
    actionType: weatherWarningsFetchTypes,
  ): boolean => {
    // all request types should be for this page load
    if (requestTime < pageLoadTime - 500) {
      return false;
    }
    const fetchTypeKey = REDUX_WEATHER_WARNINGS_FETCH_INIT({
      warningProps: { type: '', key: '' },
      timestamp: Date.now(),
    }).type;
    // if new fetch cannot exist in arr
    if (actionType === fetchTypeKey) {
      const matchingIndex = requestArr.findIndex(([_, itemRequest]) => itemRequest === request);
      if (matchingIndex >= 0) {
        return false;
      }
    }

    return true;
  };

  const addPageRequest = (time: number, request: string, actionType: weatherWarningsFetchTypes): boolean => {
    if (shouldMakePageRequest(time, request, actionType)) {
      requestArr.push([time, request]);
      sortByTime();
      return true;
    }
    return false;
  };

  const showArr = () => requestArr;

  return { updatePageLoadTime, addPageRequest, showArr };
}
